import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { ReactNode } from "react";

type Props = {
  modal: ReactNode;
  disabled?: boolean;
  tooltip?: string;
  label?: string;
  modalWidth?: string;
  modalTitle?: string;
};

export const BalanceBlockBtn = observer(
  ({
    modal,
    disabled,
    tooltip,
    label = "Вывести средства",
    modalWidth = "600px",
    modalTitle = "Создание заявки на вывод",
  }: Props) => {
    const { actionModals } = useStores();

    const openPayoutModalHandler = () => {
      actionModals.open(() => modal, {
        title: modalTitle,
        width: modalWidth,
        isOverlayClose: false,
        onClose: () => actionModals.closeAll(),
      });
    };

    return (
      <CustomButton
        variant="outlined"
        onClick={openPayoutModalHandler}
        className="full-width"
        disabled={disabled}
        tooltip={tooltip}
      >
        {label}
      </CustomButton>
    );
  }
);
